const render = (macros, element) => {
    if (typeof element === 'string') {
        return element;
    }
    else if (element.astType === 'Var') {
        return element.value
            ? macros.Var(element, render(macros, element.value))
            : macros.Var(element);
    }
    else if (element.astType === 'ConstVar') {
        if (!element.value) {
            throw new Error(`ConstVar ${element.name} must have an initial value`);
        }
        return macros.ConstVar(element, render(macros, element.value));
    }
    else if (element.astType === 'Func') {
        return macros.Func(element, element.args.map((arg) => arg.value ? render(macros, arg.value) : null), render(macros, element.body));
    }
    else if (element.astType === 'Class') {
        return macros.Class(element);
    }
    else if (element.astType === 'Sequence') {
        return element.content.map((child) => render(macros, child)).join('');
    }
    else {
        throw new Error(`Unexpected element in AST ${element}`);
    }
};

export { render as default };
